import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "suffix", "input"]
  static values = {
    units: Object,
    conversionFactor: Number
  }

  filterNumeric(event) {
    if (["e", "E", "+", "-"].includes(event.key)) event.preventDefault()
  }

  filterPaste(event) {
    event.preventDefault()
    const numeric = event.clipboardData.getData("text").replace(/[^0-9]/g, "")
    if (!numeric) return
    const input = event.target
    const { selectionStart: start, selectionEnd: end, value } = input
    input.value = value.slice(0, start) + numeric + value.slice(end)
    input.setSelectionRange(start + numeric.length, start + numeric.length)
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  updateUnit(event) {
    const countryId = event.target.value
    if (!countryId) return

    const newUnit = this.unitsValue[countryId]
    if (!newUnit) return

    const currentUnit = this.hasSuffixTarget ? this.suffixTarget.textContent.trim() : null

    if (this.hasInputTarget && currentUnit && currentUnit !== newUnit && this.inputTarget.value !== "") {
      const currentValue = parseFloat(this.inputTarget.value)

      if (!isNaN(currentValue)) {
        if (currentUnit === "KM" && newUnit === "MI") {
          this.inputTarget.value = Math.round(currentValue / this.conversionFactorValue)
        } else if (currentUnit === "MI" && newUnit === "KM") {
          this.inputTarget.value = Math.round(currentValue * this.conversionFactorValue)
        }
      }
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = newUnit
    }

    if (this.hasSuffixTarget) {
      this.suffixTarget.textContent = newUnit
    }
  }
}
